import { gateway } from "../../../gateway";

export interface IRetrySubscriptionPaymentResponse {
  status: number;
  message: string;
  data: IRetrySubscriptionPaymentResponseData;
}

export interface IRetrySubscriptionPaymentResponseData {
  paypalSubscriptionId: string;
  statusBefore: string;
  statusAfter: string;
  retryAttempted: boolean;
  captureExecuted: boolean;
  activateExecuted: boolean;
  outstandingBalanceBefore: {
    currency_code: string;
    value: string;
  } | null;
  outstandingBalanceAfter: {
    currency_code: string;
    value: string;
  } | null;
  recovered: boolean;
  message: string;
}

export const retrySubscriptionPayment = async (subscriptionId: string): Promise<IRetrySubscriptionPaymentResponse> => {
  const { data } = await gateway.post<IRetrySubscriptionPaymentResponse>("/paypal/subscription/retry-payment", { subscriptionId });

  return data;
};
